import React, { useState } from "react";
import CryptoJS from "crypto-js";

const CouponActivateModal = ({ onClose, onSave }) => {
    const [formData, setFormData] = useState({
        coupon: "",
    });

    const couponRegex = /^[A-Z0-9]{4}(-[A-Z0-9]{4})*$/;

    // Automatically format Coupon Code
    const formatCouponCode = (value) => {
        // Remove all non-alphanumeric characters (except for dashes)
        const sanitizedValue = value.replace(/[^A-Z0-9]/g, "").toUpperCase();

        // Insert dashes every four characters
        const formattedValue = sanitizedValue
            .match(/.{1,4}/g) // Split into groups of 4 characters
            ?.join("-") // Join with dashes
            .substring(0, 19) || ""; // Limit to 19 characters (XXXX-XXXX-XXXX)

        return formattedValue;
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;

        let formattedValue = value;

        // If editing the coupon code, format it
        if (name === "coupon") {
            formattedValue = formatCouponCode(value);
        }

        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: formattedValue,
        }));
    };

    const handleSubmit = () => {
        // Proceed with the save action
        onSave(formData);
        onClose();
    };

    // Close modal when 'X' or Cancel is clicked
    const handleClose = () => {
        onClose();
    };

    // Close modal when clicking on overlay
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };

    return (
        <div className="modal-overlay" onClick={handleOverlayClick}>
            <div className="modal-container">
                <div className="modal-header">
                    <h2 className="modal-title">Activate Device</h2>
                    <button className="modal-close" onClick={handleClose}>
                        ✕
                    </button>
                </div>
                <div className="modal-body">
                    <div className="form-group">
                        <label className="form-label">Enter Your Coupon Code:</label>
                        <input
                            type="text"
                            className="form-input"
                            autoComplete="off"
                            name="coupon"
                            value={formData.coupon}
                            onChange={handleInputChange}
                            placeholder="XXXX-XXXX-XXXX-XXXX"
                            required
                        />
                        <small style={{color: 'rgba(255, 255, 255, 0.7)', fontSize: '12px', marginTop: '5px', display: 'block'}}>
                            Format: 4-character groups separated by dashes
                        </small>
                    </div>
                </div>
                <div className="modal-footer">
                    <button onClick={handleClose} className="btn btn-secondary">
                        Cancel
                    </button>
                    <button onClick={handleSubmit} className="btn btn-success" disabled={!formData.coupon.trim()}>
                        Activate now
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CouponActivateModal;
